import { Component } from '@angular/core';

@Component({
  selector: 'app-krdya-logo-white',
  templateUrl: './krdya-logo-white.component.html',
  styleUrls: ['./krdya-logo-white.component.scss']
})
export class KrdyaLogoWhiteComponent {

}
